export const tagDefaultColor = "#bcbcbc";
